import styled from "styled-components";
import Box from "./Box";
// a button styled thing which is actually just a label?
const ButtonAsLabel = styled(Box).attrs({
  centered: true,
  styledMinHeight: "32px"
}).withConfig({
  displayName: "ButtonAsLabel",
  componentId: "sc-8cdfis-0"
})(["border-radius:0 16px 16px 0;", " ", ""], props => props.light && "\n      background: ".concat(props.theme.textLight, ";\n      color: ").concat(props.theme.textDark, ";\n    "), props => !props.light && "\n      background: ".concat(props.theme.textBlack, ";\n      color: ").concat(props.theme.textLight, ";\n    "));
export default ButtonAsLabel;